export default {
	"scanPay.FailedToGenerateOrder": "Failed to generate order",
	"scanPay.paymentSuccessful": "payment successful",
	"scanPay.Purchases": "Purchases:",
	"scanPay.OrderNumber": "Order number:",
	"scanPay.TheAmountActuallyPaid": "The amount actually paid:"
}